// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./Utilities/LoggerUtils.bs.js";
import * as PaymentLoader$OrcaPaymentPage from "./Components/PaymentLoader.bs.js";

function ThreeDSMethod(props) {
  let logger = HyperLogger$OrcaPaymentPage.make(undefined, {
    TAG: "Elements",
    _0: "Payment"
  }, undefined, undefined, undefined);
  let stateMetadataRef = React.useRef({});
  let consumePostMessageForThreeDsMethodCompletionRef = React.useRef(false);
  let threeDsUrlRef = React.useRef("");
  let iframeRef = React.useRef(null);
  let initialLoadDoneRef = React.useRef(false);
  let isThreeDSMethodCompletionFired = React.useRef(false);
  let isThreeDSMethodFlowStarted = React.useRef(false);
  let match = React.useState(() => false);
  let setIsClearInterval = match[1];
  let isClearInterval = match[0];
  let match$1 = React.useState(() => false);
  let setIsStartTimeout = match$1[1];
  let isStartTimeout = match$1[0];
  let match$2 = React.useState(() => false);
  let setIsStartPolling = match$2[1];
  let isStartPolling = match$2[0];
  let handleIframeContentLoaded = () => {
    Utils$OrcaPaymentPage.getDictFromJson(stateMetadataRef.current)["3dsMethodComp"] = "Y";
    let metadataDict = Core__Option.getOr(Core__JSON.Decode.object(stateMetadataRef.current), {});
    let iframeId = Utils$OrcaPaymentPage.getString(metadataDict, "iframeId", "");
    if (iframeId.length > 0 && !isThreeDSMethodCompletionFired.current) {
      LoggerUtils$OrcaPaymentPage.handleLogging(logger, "Y", "THREE_DS_METHOD_RESULT", "CARD", undefined);
      isThreeDSMethodCompletionFired.current = true;
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "fullscreen",
          false
        ],
        [
          "param",
          "paymentloader"
        ],
        [
          "iframeId",
          iframeId
        ]
      ]);
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "fullscreen",
          true
        ],
        [
          "param",
          `3dsAuth`
        ],
        [
          "iframeId",
          iframeId
        ],
        [
          "metadata",
          stateMetadataRef.current
        ]
      ]);
    }
  };
  let getIframeContentDocument = () => {
    let contentWindowDoc = Core__Option.flatMap(Core__Option.flatMap(Primitive_option.fromNullable(iframeRef.current), ele => Primitive_option.fromNullable(ele.contentWindow)), ele => Primitive_option.fromNullable(ele.document));
    let contentDocument = Core__Option.flatMap(Primitive_option.fromNullable(iframeRef.current), ele => Primitive_option.fromNullable(ele.contentDocument));
    if (contentDocument !== undefined) {
      return Primitive_option.some(Primitive_option.valFromOption(contentDocument));
    } else {
      return contentWindowDoc;
    }
  };
  let handleOnLoad = param => {
    if (consumePostMessageForThreeDsMethodCompletionRef.current) {
      return;
    }
    try {
      let doc = getIframeContentDocument();
      if (doc === undefined) {
        return;
      }
      let currentUrl = Primitive_option.valFromOption(doc).location.href;
      if (!initialLoadDoneRef.current && (currentUrl === "about:blank" || currentUrl === "")) {
        initialLoadDoneRef.current = true;
        return;
      } else {
        return handleIframeContentLoaded();
      }
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      let errorName = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.formatException(err)), "type", "");
      if (errorName === "SecurityError") {
        return handleIframeContentLoaded();
      } else {
        return;
      }
    }
  };
  let handleOnError = value => {
    LoggerUtils$OrcaPaymentPage.handleLogging(logger, value, "THREE_DS_METHOD_RESULT", "CARD", "ERROR");
    Utils$OrcaPaymentPage.getDictFromJson(stateMetadataRef.current)["3dsMethodComp"] = "N";
    let metadataDict = Core__Option.getOr(Core__JSON.Decode.object(stateMetadataRef.current), {});
    let iframeId = Utils$OrcaPaymentPage.getString(metadataDict, "iframeId", "");
    if (iframeId.length > 0 && !isThreeDSMethodCompletionFired.current) {
      isThreeDSMethodCompletionFired.current = true;
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "fullscreen",
          true
        ],
        [
          "param",
          `3dsAuth`
        ],
        [
          "iframeId",
          iframeId
        ],
        [
          "metadata",
          stateMetadataRef.current
        ]
      ]);
    }
  };
  let pollForCompletion = () => {
    if (isThreeDSMethodCompletionFired.current) {
      return setIsClearInterval(param => true);
    }
    try {
      let doc = getIframeContentDocument();
      if (doc === undefined) {
        return;
      }
      let doc$1 = Primitive_option.valFromOption(doc);
      let currentUrl = doc$1.location.href;
      if (doc$1.readyState === "complete" && initialLoadDoneRef.current && currentUrl !== "about:blank" && currentUrl !== "") {
        handleIframeContentLoaded();
        setIsClearInterval(param => true);
      }
      if (!initialLoadDoneRef.current && currentUrl === "about:blank") {
        initialLoadDoneRef.current = true;
        return;
      } else {
        return;
      }
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      let errorName = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.formatException(err)), "type", "");
      if (errorName === "SecurityError") {
        setIsClearInterval(param => true);
        return handleIframeContentLoaded();
      } else {
        return;
      }
    }
  };
  React.useEffect(() => {
    if (!isStartPolling) {
      return;
    }
    let intervalId = setInterval(() => pollForCompletion(), 200);
    if (isClearInterval) {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [
    isClearInterval,
    isStartPolling
  ]);
  React.useEffect(() => {
    if (!isStartTimeout) {
      return;
    }
    let timeoutId = setTimeout(() => handleOnError("Timeout while waiting for ThreeDS Method completion"), 15000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isStartTimeout]);
  React.useEffect(() => {
    let handle = ev => {
      try {
        let json = Utils$OrcaPaymentPage.safeParse(ev.data);
        let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
        if (Core__Option.isSome(dict["fullScreenIframeMounted"]) && !isThreeDSMethodFlowStarted.current) {
          isThreeDSMethodFlowStarted.current = true;
          let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
          stateMetadataRef.current = metadata;
          let metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
          let threeDsDataDict = Core__Option.getOr(Core__Option.flatMap(metaDataDict["threeDSData"], Core__JSON.Decode.object), {});
          let threeDsMethodDetails = Utils$OrcaPaymentPage.getDictFromDict(threeDsDataDict, "three_ds_method_details");
          consumePostMessageForThreeDsMethodCompletionRef.current = Utils$OrcaPaymentPage.getBool(threeDsMethodDetails, "consume_post_message_for_three_ds_method_completion", false);
          let paymentIntentId = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentIntentId", "");
          let publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
          let sdkAuthorization = Utils$OrcaPaymentPage.getString(metaDataDict, "sdkAuthorization", "");
          logger.setClientSecret(paymentIntentId);
          logger.setSdkAuthorization(sdkAuthorization);
          logger.setMerchantId(publishableKey);
          let ele = document.querySelector("#threeDsInvisibleDiv");
          if (ele == null) {
            handleOnError("Unable to Locate threeDsInvisibleDiv");
          } else {
            threeDsUrlRef.current = Utils$OrcaPaymentPage.getString(threeDsMethodDetails, "three_ds_method_url", "");
            let threeDsMethodData = Utils$OrcaPaymentPage.getString(threeDsMethodDetails, "three_ds_method_data", "");
            let threeDsMethodKey = Utils$OrcaPaymentPage.getString(threeDsMethodDetails, "three_ds_method_key", "threeDSMethodData");
            let form = Utils$OrcaPaymentPage.makeForm(ele, threeDsUrlRef.current, "threeDsHiddenPostMethod");
            let input = document.createElement("input");
            input.name = encodeURIComponent(threeDsMethodKey);
            input.value = encodeURIComponent(threeDsMethodData);
            form.target = "threeDsInvisibleIframe";
            form.appendChild(input);
            try {
              if (!consumePostMessageForThreeDsMethodCompletionRef.current) {
                setIsStartPolling(param => true);
              }
              setIsStartTimeout(param => true);
              form.submit();
            } catch (raw_err) {
              let err = Primitive_exceptions.internalToException(raw_err);
              handleOnError(JSON.stringify(Utils$OrcaPaymentPage.formatException(err)));
            }
          }
        }
      } catch (_err) {
        
      }
      if (!(consumePostMessageForThreeDsMethodCompletionRef.current && threeDsUrlRef.current !== "")) {
        return;
      }
      let url = new URL(threeDsUrlRef.current);
      if (url.origin === ev.origin) {
        return handleIframeContentLoaded();
      }
    };
    window.addEventListener("message", handle);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(PaymentLoader$OrcaPaymentPage.make, {}),
      JsxRuntime.jsx("div", {
        className: "hidden",
        id: "threeDsInvisibleDiv"
      }),
      JsxRuntime.jsx("iframe", {
        ref: Primitive_option.some(iframeRef),
        className: "h-96 invisible",
        id: "threeDsInvisibleIframe",
        style: {
          outline: "none"
        },
        title: "3D Secure Invisible Frame",
        name: "threeDsInvisibleIframe",
        onError: param => handleOnError("ThreeDS Method Iframe Load Error"),
        onLoad: handleOnLoad
      })
    ]
  });
}

let make = ThreeDSMethod;

export {
  make,
}
/* react Not a pure module */
